<div class="history-container">
  <h3>Upload History</h3>
  <div class="table-responsive">
    <table>
      <thead>
        <tr>
          <th>Period</th>
          <th>File Name</th>
          <th>Last Uploaded</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of displayedPeriods">
          <td class="period-cell">{{ item.period }}</td>
          <td>{{ item.fileName }}</td>
          <td>{{ item.uploadedAt | date:'medium' }}</td>
          <td class="actions-cell">
            <button class="action-btn view-btn" (click)="openDetailModal(item.period)">View Detail</button>
            <button class="delete-btn" (click)="deleteHistory(item.period)" title="Delete">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </button>
          </td>
        </tr>
        <tr *ngIf="displayedPeriods.length === 0"><td colspan="3" class="empty-state">No uploads found.</td></tr>
        
      </tbody>
    </table>
  </div>
  
  <div class="view-all-container" *ngIf="uniquePeriods.length > 3">
    <button class="action-btn view-btn" (click)="toggleHistory()">
      {{ isExpanded ? 'Show Less' : 'View History' }}
    </button>
  </div>
</div>

<!-- Full History Modal -->
<div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
  <div class="history-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Upload History: {{ selectedPeriod }}</h2>
      <button class="close-btn" (click)="closeModal()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="table-responsive">
        <table>
          <thead>
            <tr>
              <th>File Name</th>
              <th>Records</th>
              <th>Uploaded Date</th>
              <th>Uploaded By</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of paginatedModalHistory">
              <td>{{ item.fileName }}</td>
              <td>{{ item.recordCount }}</td>          
              <td>{{ item.uploadedAt | date:'medium' }}</td>
              <td>{{ item.uploadedBy }}</td>
              <td class="actions-cell">
                <a *ngIf="item.downloadURL" [href]="item.downloadURL" target="_blank" class="action-btn download-btn" title="Download Raw File">Download</a>
                <button class="delete-btn" (click)="deleteSingleFile(item)" title="Delete this file">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-controls">
        <button class="action-btn" (click)="changePage(-1)" [disabled]="currentPage === 1">Previous</button>
        <span>Page {{ currentPage }} of {{ totalPages }}</span>
        <button class="action-btn" (click)="changePage(1)" [disabled]="currentPage === totalPages">Next</button>
      </div>
    </div>
  </div>
</div>
